<template>
  <header class="header">
    <div class="section-frame">
      <div class="header-top">
        <ul>
          <li v-if="false">
            <a href="#">{{ $t("instructions") }}</a>
          </li>
        </ul>
        <ul style="margin-left: auto; margin-right: 50px">
          <li style="margin-right: 10px">
            <a
              @click.prevent="setLang('lat2cyr')"
              :class="{ active: $store.getters.lang === 'lat2cyr' }"
              href="#"
              >O'zbekcha</a
            >
          </li>
          <li>
            <a
              @click.prevent="setLang('russian')"
              :class="{ active: $store.getters.lang === 'russian' }"
              href="#"
              >Русский</a
            >
          </li>
        </ul>
        <a href="tel:1355" class="header-phone"><i class="fa-phone"></i>1355</a>
      </div>
    </div>
    <div class="header-content">
      <div class="section-frame">
        <div class="header-bar">
          <router-link to="/" class="logo">
            <img @click="upTop" src="../assets/images/logo.svg" alt="" />
          </router-link>
          <nav class="main-nav">
            <ul>
              <li class="active-page">
                <router-link to="/courses"
                  ><i class="fa-square"></i>
                  <div>{{ $t("catalog") }}</div></router-link
                >
              </li>
              <li v-if="news">
                <router-link to="/news"
                  ><div>{{ $t("news_and_discounts") }}</div></router-link
                >
              </li>
              <li>
                <router-link to="/certified-courses"
                  ><div>{{ $t("certificated_courses") }}</div></router-link
                >
              </li>
              <li>
                <router-link to="/attestations"
                  ><div>{{ $t("attestation") }}</div></router-link
                >
              </li>
              <li>
                <router-link to="/contact"
                  ><div>{{ $t("contact") }}</div></router-link
                >
              </li>
            </ul>
          </nav>
          <div class="header-button">
            <!-- <router-link to="/cart"
              ><i class="fa-cart-fill"></i>
              <span
                class="user-notification"
                v-if="cart && cart.carts.length"
                >{{ cart.carts.length }}</span
              >
              <div>{{ $t('cart') }}</div>
            </router-link> -->
            <router-link v-if="token && user" to="/profile"
              ><i class="fa-user"></i>
              <span
                class="user-notification"
                v-if="wishlist && wishlist.length"
                >{{ wishlist.length }}</span
              >
              <span
                class="user-notification"
                v-if="notification && notification_count"
                >{{ notification_count }}</span
              >
              <div>{{ $t("profile") }}</div>
              <svg
                class="invalid"
                v-if="
                  user.first_name === '' ||
                  user.last_name === '' ||
                  user.full_name === '' ||
                  user.date_birth === '' ||
                  user.login === '' ||
                  user.city === ''
                "
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 192 512"
              >
                <path
                  fill="currentColor"
                  d="M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
                ></path>
              </svg>
            </router-link>
            <router-link v-else to="/login"
              ><i class="fa-out"></i>{{ $t("login") }}</router-link
            >
          </div>
          <div class="burger" @click="navMenu = !navMenu">
            <span></span>
            <span></span>
            <span></span>
            <i class="fa-close menu-close"></i>
          </div>
        </div>
      </div>
    </div>
    <transition v-on:enter="enter" v-on:leave="leave">
      <div class="mob-menu" v-show="navMenu">
        <nav class="main-nav">
          <ul>
            <li class="active-page" @click="navMenu = false">
              <router-link to="/courses"
                ><i class="fa-square"></i>{{ $t("catalog") }}</router-link
              >
            </li>
            <li @click="navMenu = false">
              <router-link to="/news"
                ><div>{{ $t("news_and_discounts") }}</div></router-link
              >
            </li>
            <li @click="navMenu = false">
              <router-link to="/attestations"
                ><div>{{ $t("attestation") }}</div></router-link
              >
            </li>
            <li @click="navMenu = false">
              <router-link to="/contact"
                ><div>{{ $t("contact") }}</div></router-link
              >
            </li>
          </ul>
        </nav>
        <a href="tel:+1355" class="header-phone"
          ><i class="fa-phone"></i>{{ $t("phone_number") }}</a
        >
        <ul class="mob-lang-switcher">
          <li>
            <a
              @click.prevent="setLang('lat2cyr')"
              :class="{ active: $store.getters.lang === 'lat2cyr' }"
              href="#"
              >O'zbekcha</a
            >
          </li>
          <li>
            <a
              @click.prevent="setLang('russian')"
              :class="{ active: $store.getters.lang === 'russian' }"
              href="#"
              >Русский</a
            >
          </li>
        </ul>
      </div>
    </transition>
  </header>
</template>

<script>
import Velocity from "velocity-animate";

export default {
  data() {
    return {
      navMenu: false,
    };
  },
  methods: {
    setClass: function (navMenu) {
      if (navMenu === true) {
        return "open";
      }
      return "close";
    },

    enter: function (el, done) {
      Velocity(
        el,
        "slideDown",
        {
          duration: 300,
          easing: "easeInBack",
        },
        { complete: done },
      );
    },

    leave: function (el, done) {
      Velocity(
        el,
        "slideUp",
        {
          duration: 300,
          easing: "easeInBack",
        },
        { complete: done },
      );
    },
    upTop() {
      window.scrollTo(0, 0);
    },
    setLang(e) {
      this.$store.dispatch("putLang", e);
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUserCredentials;
    },
    cart() {
      return this.$store.getters.getCart;
    },
    lang() {
      return this.$store.getters.lang;
    },
    wishlist() {
      return this.$store.getters.getWishlist;
    },
    notification() {
      return this.$store.getters.getNotifications;
    },
    notification_count() {
      if (!this.notification) return 0;
      return this.notification.filter((e) => !e.show_status).length;
    },
    news() {
      return this.$store.getters.getNews;
    },
    token() {
      return this.$store.getters.getIsAuthenticated;
    },
  },
};
</script>
